export default __webpack_public_path__ + "static/media/admin_gs_logo.6fdb3338.png";